import React from 'react';
import { NativeSelect, InputBase } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const BootstrapInput = withStyles(theme => ({
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme?.palette?.background?.paper,
    border: '1px solid #ced4da',
    fontSize: 14,
    fontFamily: ['Titillium', 'sans-serif'].join(','),
    padding: '8px 26px 10px 12px',
    transition: theme?.transitions?.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

export function SelectInput({
  label,
  labelClasses = '',
  classes = 'd-flex align-items-center',
  options = [],
  selectSize = '100%',
  labelMinSize,
  formik,
  description = 'description',
  field,
  buildDescription,
  value = 'id',
}) {
  return (
    <div className={`form-group fv-plugins-icon-container ${classes}`}>
      <label className={labelClasses} style={{ minWidth: labelMinSize }}>
        {label}
      </label>
      <NativeSelect
        className="form-select"
        style={{ width: selectSize, height: 40.5 }}
        {...formik.getFieldProps(field)}
        input={<BootstrapInput />}
      >
        {options.map(opt =>
          !buildDescription ? (
            <option value={opt[value]} key={opt[value]}>
              {' '}
              {opt[description]}{' '}
            </option>
          ) : (
            <option value={opt[value]} key={opt[value]}>
              {' '}
              {buildDescription(opt)}{' '}
            </option>
          )
        )}
      </NativeSelect>
      {formik.touched[field] && formik.errors[field] ? (
        <div className="d-flex">
          <label style={{ minWidth: labelMinSize }}> </label>
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">{formik.errors[field]}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
